<template>
  <div class="sign-in-reward">
    <div class="header-process">
      <span>宝箱次数:</span>
      <el-input style="width: 180px; margin: 0 10px" type="number" v-model="searchForm.boxTimes"
        placeholder="请输入宝箱次数" />
      <span>状态:</span>
      <el-select v-model="searchForm.valid" placeholder="请选择">
        <el-option v-for="item in otherOptions.validList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <span>渠道:</span>
      <el-select v-model="searchForm.channel" placeholder="请选择" filterable>
        <el-option v-for="item in otherOptions.channelList" :key="item.value" :label="item.name" :value="item.value">
        </el-option>
      </el-select>
      <!-- <span>用户组:</span>
      <el-select v-model="searchForm.userGroup" placeholder="请选择" clearable>
        <el-option v-for="item in otherOptions.userGroupList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select> -->
      <el-button type="primary" @click="getSignTableData">查询</el-button>
      <el-button type="success" @click="dialogShow(false)">新增</el-button>
    </div>
    <el-table :data="rewardTable" border style="width: 100%" height="920">
      <el-table-column prop="boxTimes" label="阶段" width="120" />
      <el-table-column prop="channel" label="渠道" />
      <el-table-column prop="coinRandomMin" label="奖励随机数最小值" />
      <el-table-column prop="coinRandomMax" label="奖励随机数最大值" />
      <el-table-column prop="waitDuration" label="等待时长" />
      <el-table-column prop="secCoinRandomMin" label="第二套奖励金币随机最小值" />
      <el-table-column prop="secCoinRandomMax" label="第二套奖励金币随机最大值" />
      <el-table-column prop="secWaitDuration" label="第二套等待时长（s）" />
      <el-table-column prop="rewardType" label="奖励类型">
        <template slot-scope="scope">
          {{ scope.row.rewardType === 1 ? '游戏货币' : scope.row.rewardType === 0 ? '金币' : scope.row.rewardType === -1 ? '游戏货币+金币组合' : '' }}
        </template>
      </el-table-column>
      <el-table-column prop="userGroup" label="用户组">
        <template slot-scope="scope">
          {{ scope.row.userGroup === 0 ? '默认用户' : scope.row.userGroup === 1 ? '推广用户' : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="activityType" label="是否有效">
        <template slot-scope="scope">
          {{ scope.row.valid === 1 ? '有效' : '无效' }}
        </template>
      </el-table-column>
      <el-table-column prop="ctime" label="操作时间">
        <template slot-scope="scope">
          {{ dateFormat(scope.row.ctime * 1000) }}
        </template>
      </el-table-column>
      <el-table-column prop="operator" label="操作人"></el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="warning" @click="dialogShow(true, scope.row)">更新</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialogData.isEdit ? '编辑' : '新增'" :visible.sync="dialogData.visible" width="40%"
      :before-close="handleDialogClose">
      <el-form ref="form" label-position="left" :model="dialogData.data" label-width="190px">
        <el-form-item label="天数:">
          <el-input style="width: 180px; margin: 0 10px" type="number" v-model="dialogData.data.boxTimes"
            placeholder="请输入天数" />
        </el-form-item>
        <el-form-item label="渠道:">
          <el-select v-model="dialogData.data.channelList" multiple placeholder="请选择" filterable>
            <el-option v-for="item in otherOptions.channelList" :key="item.value" :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="奖励金币随机数最小值:">
          <el-input style="width: 180px; margin: 0 10px" type="number" v-model="dialogData.data.coinRandomMin"
            placeholder="请输入最小值" />
        </el-form-item>
        <el-form-item label="奖励金币随机数最大值:">
          <el-input style="width: 180px; margin: 0 10px" type="number" v-model="dialogData.data.coinRandomMax"
            placeholder="请输入最大值" />
        </el-form-item>
        <el-form-item label="宝箱计时时长:">
          <el-input style="width: 180px; margin: 0 10px" type="number" v-model="dialogData.data.waitDuration"
            placeholder="请输入宝箱计时时长" />
        </el-form-item>
        <el-form-item label="第二套奖励金币随机最小值:">
          <el-input style="width: 180px; margin: 0 10px" type="number" v-model="dialogData.data.secCoinRandomMin"
            placeholder="请输入最小值" />
        </el-form-item>
        <el-form-item label="第二套奖励金币随机最大值:">
          <el-input style="width: 180px; margin: 0 10px" type="number" v-model="dialogData.data.secCoinRandomMax"
            placeholder="请输入最大值" />
        </el-form-item>
        <el-form-item label="第二套等待时长（s）:">
          <el-input style="width: 180px; margin: 0 10px" type="number" v-model="dialogData.data.secWaitDuration"
            placeholder="请输入时长" />
        </el-form-item>
        <el-form-item label="奖励类型:">
          <el-radio-group v-model="dialogData.data.rewardType">
            <el-radio :label="0">金币</el-radio>
            <el-radio :label="1">游戏货币</el-radio>
            <el-radio :label="-1">游戏货币+金币组合</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="用户组:">
          <el-radio-group v-model="dialogData.data.userGroup">
            <el-radio :label="0">默认用户</el-radio>
            <el-radio :label="1">推广用户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否有效:">
          <el-radio-group v-model="dialogData.data.valid">
            <el-radio :label="1">有效</el-radio>
            <el-radio :label="0">无效</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="handleDialogClose">取消</el-button>
        <el-button type="primary" @click="submitUpdateReward">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getTimeBoxTable,
  updateTimeBoxTable,
} from '@/api/rewardConfigRequest.js'
export default {
  data() {
    return {
      // 搜索表单
      searchForm: {
        channel: 'All',
        boxTimes: '',
        valid: null,
        userGroup: null,
      },
      options: [],
      value: '',
      // 搜索的list
      otherOptions: {
        dayList: [
          { label: '全部', value: 0 },
          { label: '1', value: 1 },
          { label: '2', value: 2 },
          { label: '3', value: 3 },
        ],
        channelList: [],
        validList: [
          { label: '全部', value: null },
          { label: '有效', value: 1 },
          { label: '无效', value: 0 },
        ],
        userGroupList: [
          { label: '全部', value: null },
          { label: '默认用户', value: 0 },
          { label: '推广用户', value: 1 },
        ],
      },
      // 奖励表
      rewardTable: [],
      dialogData: {
        isEdit: false,
        visible: false,
        data: {
          boxTimes: '',
          channelList: [],
          valid: 1,
          rewardType: 0,
          userGroup: 0,
          waitDuration: 0,
          coinRandomMin: 0,
          coinRandomMax: 0,
          secCoinRandomMin: 0,
          secCoinRandomMax: 0,
          secWaitDuration: 0,
        },
      },
    }
  },
  mounted() {
    this.getAppList()
    this.getSignTableData()
  },
  methods: {
    dateFormat(input, pattern = '') {
      // 在参数列表中 通过 pattern="" 来指定形参默认值，防止报错
      var dt = new Date(input)
      // 获取年月日
      var y = dt.getFullYear()
      var m = (dt.getMonth() + 1).toString().padStart(2, '0')
      var d = dt.getDate().toString().padStart(2, '0')
      // 如果 传递进来的字符串类型，转为小写之后，等于 yyyy-mm-dd，那么就返回 年-月-日
      // 否则，就返回  年-月-日 时：分：秒
      if (pattern.toLowerCase() === 'yyyy-mm-dd') {
        return `${y}-${m}-${d}`
      } else {
        // 获取时分秒
        var hh = dt.getHours().toString().padStart(2, '0')
        var mm = dt.getMinutes().toString().padStart(2, '0')
        var ss = dt.getSeconds().toString().padStart(2, '0')
        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
      }
    },
    // 展示提示消息
    showMsg(res) {
      if (res.code === 0) {
        this.$message({ type: 'success', message: res.msg })
      } else {
        this.$message({ type: 'warning', message: res.msg })
      }
    },
    // 获取渠道列表
    async getAppList() {
      const { data: res } = await this.$axios(
        this.$store.getters.path.channelList +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      )
      if (res.code == 0) {
        this.otherOptions.channelList = res.data
        this.otherOptions.channelList.unshift({ label: 'ALL', value: 'ALL' })
      }
    },
    // 获取签到表
    async getSignTableData() {
      const res = await getTimeBoxTable(this.searchForm)
      this.showMsg(res)
      if (res.code === 0) {
        this.rewardTable = res.data
      }
    },
    // 弹窗弹起
    dialogShow(isEdit, row) {
      this.dialogData.visible = true
      if (isEdit) {
        this.dialogData.data.boxTimes = row.boxTimes
        this.dialogData.data.valid = row.valid
        this.dialogData.data.rewardType = row.rewardType
        this.dialogData.data.userGroup = row.userGroup !== undefined ? row.userGroup : 0
        this.dialogData.data.channelList = [row.channel]
        console.log(typeof row.waitDuration)
        this.dialogData.data.waitDuration = row.waitDuration
        this.dialogData.data.coinRandomMin = row.coinRandomMin
        this.dialogData.data.coinRandomMax = row.coinRandomMax
        this.dialogData.data.secCoinRandomMin = row.secCoinRandomMin || 0
        this.dialogData.data.secCoinRandomMax = row.secCoinRandomMax || 0
        this.dialogData.data.secWaitDuration = row.secWaitDuration || 0
        this.$set(this.dialogData.data, 'id', row.id)
        this.dialogData.isEdit = true
      } else {
        this.dialogData.isEdit = false
        this.dialogData.data = {
          boxTimes: '',
          channelList: [],
          valid: 1,
          rewardType: 0,
          userGroup: 0,
          waitDuration: 0,
          coinRandomMin: 0,
          coinRandomMax: 0,
          secCoinRandomMin: 0,
          secCoinRandomMax: 0,
          secWaitDuration: 0,
        }
      }
    },
    handleDialogClose() {
      this.dialogData.visible = false
      this.dialogData.data = {
        boxTimes: '',
        channelList: [],
        valid: 1,
        rewardType: 0,
        userGroup: 0,
      }
    },
    // 提交新增/修改操作
    async submitUpdateReward() {
      // 将this.dialogData.data里的waitDuration, coinRandomMin, coinRandomMax转为number类型

      // this.dialogData.data.boxTimes = Number(this.dialogData.data.boxTimes)
      this.dialogData.data.waitDuration = Number(
        this.dialogData.data.waitDuration
      )
      this.dialogData.data.coinRandomMin = Number(
        this.dialogData.data.coinRandomMin
      )
      this.dialogData.data.coinRandomMax = Number(
        this.dialogData.data.coinRandomMax
      )
      this.dialogData.data.secCoinRandomMin = Number(
        this.dialogData.data.secCoinRandomMin
      )
      this.dialogData.data.secCoinRandomMax = Number(
        this.dialogData.data.secCoinRandomMax
      )
      this.dialogData.data.secWaitDuration = Number(
        this.dialogData.data.secWaitDuration
      )
      if (
        this.dialogData.data.coinRandomMin >=
        this.dialogData.data.coinRandomMax &&
        this.dialogData.data.valid == 1
      ) {
        return this.$message.error('奖励最小值数要小于最大值')
      }
      console.log(typeof this.dialogData.data.secCoinRandomMin)
      const res = await updateTimeBoxTable(this.dialogData.data)
      this.showMsg(res)
      if (res.code === 0) {
        this.getSignTableData()
        this.dialogData.visible = false
      }
    },
  },
}
</script>
<style scoped lang="scss">
.sign-in-reward {
  .el-select {
    margin: 0 10px;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
